// @ts-nocheck
import React from 'react';

const StudentyPage = () => {
  return (
    <section className="pt-2 pb-10">
      <div className="container md:px-[65px]">
        <div className="flex flex-col-reverse text-white md:flex-row">
          <div className="relative md:w-3/5 bg-[#A81414] md:h-[350px] px-6 py-2 md:p-8 md:rounded-tl-xl rounded-bl-xl max-md:rounded-br-xl">
            <h2 className="py-3 text-xl font-bold text-justify uppercase md:text-4xl hyphens-auto">Студенти </h2>
            <div className="pt-3 pb-3 max-md:leading-5 md:pl-8 hyphens-auto">
              Колегіум та Кампус – це центри поза навчальними закладами чи університетами, які пропонують проживання, духовний супровід та християнські засади для їхнього особистого розвитку. Ці центри створюють для студентів затишний простір та надають навчальну пропозицію. Зазвичай вони пов’язані з салезіянською діяльністю, в якій є й інші пропозиції для розвитку: ораторія, молодіжний центри, парафія, школа тощо. Таким чином студенти опиняються під захистом і сприянням салезіянської спільноти, відповідальної за діяльність.
            </div>
          </div>
          <div className="relative md:w-2/5">
            <div class="hidden md:block absolute md:top-1/2 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[20px] border-b-[20px] border-l-[10px]
              md:border-t-[175px] md:border-b-[175px] md:border-l-[50px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
            <div class="md:hidden block absolute bottom-0 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-b-[30px] border-l-[calc(50vw-20px)] border-r-[calc(50vw-20px)]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-l-transparent border-r-transparent border-t-transparent border-t-red-600">
            </div>
            <img
              className="md:h-[350px] object-cover object-right rounded-tr-xl md:rounded-br-xl rounded-tl-xl md:rounded-tl-none"
              src="/images/studenty.JPG"
              alt=""
            />
          </div>
        </div>
        <div className="flex flex-col justify-between py-4 md:px-16 md:flex-row">
          <div className="md:w-1/3">
            <div className="text-[#A81414] font-bold pt-2 text-lg md:text-xl uppercase">
              Кампус
            </div>
            <div className="flex my-2 max-md:ml-4">
              <div className="hidden md:flex border-[2px] border-[#A81414] mr-6">
              </div>
              <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
              </div>
              <div>
                <div className="pt-3">
                  Відповідальний: о.Роман Боднар, СДБ
                </div>
                <div className="pb-3">
                  +380 96 520 36 60
                </div>
                <div className="">
                  Вул. Личаківська, 175
                </div>
                <div className="">
                  Львів
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-1/3">
            <div className="text-[#A81414] font-bold pt-2 text-lg md:text-xl uppercase">
              Колегіум
            </div>
            <div className="flex my-2 max-md:ml-4">
              <div className="hidden md:flex border-[2px] border-[#A81414] mr-6">
              </div>
              <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
              </div>
              <div>
                <div className="pt-3">
                  Відповідальний: о.Петро Васьків, СДБ
                </div>
                <div className="pb-3">
                  +380 97 370 73 33
                </div>
                <div className="">
                  Вул. Дорога Кривчицька, 19
                </div>
                <div className="">
                  Львів
                </div>
              </div>
            </div>
          </div>
          <div className="w-1/3">

          </div>
        </div>

      </div>
    </section>
  );
};

export default StudentyPage;
